import {
  ClientChecklistV1,
  ClientChecklistV2,
} from "@fartherfinance/frontend/api/Entity/requests/getClientChecklistV2";

export type ClientChecklistKey = Exclude<
  keyof ClientChecklistV1 | keyof ClientChecklistV2,
  "version" | "masterDisplay" | "onboardingComplete"
>;

export type ClientChecklistDisplayValue =
  | "Investor Profile"
  | "Contact Information"
  | "Additional Information"
  | "Beneficiaries"
  | "Affiliations"
  | "Onboarding Agreement"
  | "Privacy Policy"
  | "Investment Advisory Agreement"
  | "Disclosures"
  | "Custodian Agreement";

export const clientChecklistKeyToDisplayValueMap: Record<
  ClientChecklistKey,
  ClientChecklistDisplayValue
> = {
  investorProfile: "Investor Profile",
  contactInformation: "Contact Information",
  additionalInformation: "Additional Information",
  beneficiaries: "Beneficiaries",
  affiliation: "Affiliations",
  onboardingAgreement: "Onboarding Agreement",
  privacyPolicy: "Privacy Policy",
  investmentAdvisoryAgreement: "Investment Advisory Agreement",
  fartherDisclosures: "Disclosures",
  custodianAgreement: "Custodian Agreement",
};
